import API_BASE from './api';

// profilePicture is either a base64 data URI (current format) or a legacy
// relative disk path (old uploads, kept working for backward compatibility).
const getProfilePictureSrc = (profilePicture) => {
  if (!profilePicture) return null;
  if (profilePicture.startsWith('data:')) return profilePicture;
  return `${API_BASE.replace('/api', '')}/uploads/${profilePicture}`;
};

export default getProfilePictureSrc;
